
import React, {Component} from 'react';
import { Form, Input, Button } from '../styles/search_bar_styles';


var color_list = ["#FF9400", "#1B5E20", "#880e4f", "#1a237e"]

class SearchBar extends Component {
constructor(props) {
  super(props);
  this.state = {
    ratio: props.props.data.ratio,
    terms: props.props.data.terms,
    placeholder: `search for a hotel attribute`
    }
  this.onFormSubmit = this.onFormSubmit.bind(this);
}

onFormSubmit(event) {
  event.preventDefault();

  if(this.state.terms && this.state.terms.length > 3){
    window.alert("For better results, a maximum of 4 queries are allowed.")
    return
  }
  var searchTerm = event.target.query.value
  if(!searchTerm || searchTerm.length === 0){
    return
  }
  var current_terms = this.state.terms ? this.state.terms : []
  var current_colors = Array.from(current_terms, x=>x["color"])
  var color = "None"
  for (var i = 0; i < color_list.length; i++) {
    if (!current_colors.includes(color_list[i])) {
      color = color_list[i]
    }
  }
  var term_obj = {"text": searchTerm, "color": color}
  current_terms.push(term_obj)
  this.props.searchQuery(current_terms, false);
  if(searchTerm !== "") {
    event.target.query.value = "";
  }
}

UNSAFE_componentWillReceiveProps(props) {
  this.setState({
    terms: props.props.data.terms
  });
}

render() {
  // const placeholder = `not too noisy, parking is easy, dining options`
  return (
    <Form onSubmit={this.onFormSubmit}>
      <Input placeholder= {this.state.placeholder}
        name="query"
      />
      <Button type="submit"> Add </Button>
    </Form>
    );
  }


} //end of SearchBar

export default SearchBar;
